// extracted by mini-css-extract-plugin
export default {"base":"vp__I2Y0","arrow":"vp_ttVaR","icon":"vp_PNKDo","placeholder":"vp_a9SDw","select":"vp_jipGm","error":"vp_wuMHI","big":"vp_CCzVB"};